export default {
	UPDATE_USER: 'users/update',
	CHATS: {
		MESSAGE: 'chat-message'
	},
	UPLOAD: {
		START: 'upload/start',
		FINISH: 'upload/finish',
		ERROR: 'upload/error'
	}
}